import type { OfflineDatabaseSqlStatement } from './offlineDatabase.statements';

const CACHE_METADATA_TTL_MS = 7 * 24 * 60 * 60 * 1000;

type TimestampFactory = () => number;

export const buildCacheMetadataUpsertStatement = (
  key: string,
  lastUpdated: Date,
  getTimestamp: TimestampFactory = () => Date.now()
): OfflineDatabaseSqlStatement => ({
  sql: `INSERT OR REPLACE INTO cache_metadata (key, last_updated, expires_at)
         VALUES (?, ?, ?)`,
  params: [
    key,
    lastUpdated.toISOString(),
    new Date(getTimestamp() + CACHE_METADATA_TTL_MS).toISOString(),
  ],
});

export const buildCacheMetadataSelectStatement = (
  key: string
): OfflineDatabaseSqlStatement => ({
  sql: 'SELECT last_updated, expires_at FROM cache_metadata WHERE key = ?',
  params: [key],
});
